
import { Component, OnInit } from '@angular/core';
import { ContractDto } from 'src/app/models/contractDto';
import { ContractsService } from 'src/app/services/contracts.service';
import { NotificationService } from 'src/app/services/notification.service';
import { NotificationType } from 'src/app/models/notification.message';
import { approveContractVm } from 'src/app/models/approveContractVm';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TokenService } from 'src/app/services/token.service';
import { RequestApprovalDto } from 'src/app/models/requestapproval-dto';
import { RequestApprovalsService } from 'src/app/services/requestapprovals.service';
import { ManPowersService } from 'src/app/services/man-powers.service';
import { ManPowerDto } from 'src/app/models/ManPowerDto';
import { approveManPowerVm } from 'src/app/models/approveManPowerVm';
import { ManpowerapprovalService } from 'src/app/services/manpowerapproval.service';
import { ManpowerJDDto } from 'src/app/models/requests/ManpowerJDDto';
import * as FileSaver from 'file-saver';
import { DomSanitizer } from '@angular/platform-browser';
import { UserService } from 'src/app/services/user.service';
import { Profile } from 'src/app/models/profile';
import { ManPowerDraftsService } from 'src/app/services/man-powerDrafts.service';
import { Router } from '@angular/router';
declare var bootstrap: any;

@Component({
  selector: 'app-manpower-drafts',
  templateUrl: './manpower-drafts.component.html',
  styleUrls: ['./manpower-drafts.component.css']
})
export class ManpowerDraftsComponent implements OnInit {
  ManPower: ManPowerDto[] | any;

  constructor(private manPowerDraftService: ManPowerDraftsService, private manPowerService: ManPowersService, private sanitizer: DomSanitizer, private notification: NotificationService,
    private tokenService: TokenService, private manpowerApprovalService:ManpowerapprovalService, private userService: UserService, private router: Router  ) { }


  ngOnInit(): void {

    this.loadRecords();
  }

  async loadRecords() {
    
    let resManPower = await this.manPowerDraftService.getManPower().toPromise();
    this.ManPower = <ManPowerDto[]>resManPower.responseData;
    
    const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl);
    });
  }
    
  open(data: any) {
    this.router.navigate(['/update-manpower-request'], { state: { data } });
  }
   
  deleteDraft(id: number){
     this.manPowerDraftService.deleteManPowerDraft(id).toPromise();
     location.reload();

  }
  
}
